module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('perspective-viewport', {
    attrs: {
      "mouseControlEnabled": _vm.mouseControlEnabled
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6962feb7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WaveScene.vue
// module id = 118
// module chunks = 1